/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./Program.ScoreCard.DomainIndicatorRow.vue?vue&type=template&id=442a5a7e&scoped=true"
import script from "./Program.ScoreCard.DomainIndicatorRow.vue?vue&type=script&lang=js"
export * from "./Program.ScoreCard.DomainIndicatorRow.vue?vue&type=script&lang=js"
import style0 from "./Program.ScoreCard.DomainIndicatorRow.vue?vue&type=style&index=0&id=442a5a7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442a5a7e",
  null
  
)

export default component.exports